<div class="dashboard-container container-fluid px-0 d-flex flex-column min-vh-100">
  <div class="row g-0 vh-100 overflow-hidden">
    <div
      v-if="!is_mobile"
      class="col-auto sidebar-wrapper d-flex flex-column flex-shrink-0 vh-100 overflow-hidden"
      :class="{ 'sidebar-collapsed': sidebar_collapsed }"
    >
      <PropertySidebar
        v-if="sidebar_active_property"
        :active_property="sidebar_active_property"
        :properties="sidebar_tiles"
        :active_item="sidebar_active_item"
        :can_view_portfolio="sidebar_can_view_portfolio"
        @switch-property="open_sidebar_property"
        @go-back="open_sidebar_portfolio"
        @property-menu-selected="open_sidebar_property_menu"
      />
      <PortfolioSidebar
        v-else
        :tiles="sidebar_tiles"
        @tile-clicked="open_sidebar_property"
        @global-menu-selected="open_sidebar_portfolio"
        @property-menu-selected="open_sidebar_property_menu"
        @global-selected="open_sidebar_portfolio"
      />
    </div>

    <div v-if="is_mobile && mobile_sidebar_open" class="mobile-sidebar-overlay position-fixed d-flex align-items-stretch top-0 bottom-0 start-0 end-0" @click.self="mobile_sidebar_open = false">
      <div class="mobile-sidebar-panel h-100 overflow-hidden text-dark">
        <PropertySidebar
          v-if="sidebar_active_property"
          :active_property="sidebar_active_property"
          :properties="sidebar_tiles"
          :active_item="sidebar_active_item"
          :can_view_portfolio="sidebar_can_view_portfolio"
          @switch-property="open_sidebar_property"
          @go-back="open_sidebar_portfolio"
          @property-menu-selected="open_sidebar_property_menu"
        >
          <template #sidebar-header-actions>
            <button class="sidebar-close-btn btn btn-sm bg-white border text-dark" @click="mobile_sidebar_open = false" aria-label="Close sidebar">
              <i class="bi bi-x-lg"></i>
            </button>
          </template>
        </PropertySidebar>
        <PortfolioSidebar
          v-else
          :tiles="sidebar_tiles"
          @tile-clicked="open_sidebar_property"
          @global-menu-selected="open_sidebar_portfolio"
          @property-menu-selected="open_sidebar_property_menu"
          @global-selected="open_sidebar_portfolio"
        >
          <template #sidebar-header-actions>
            <button class="sidebar-close-btn btn btn-sm bg-white border text-dark" @click="mobile_sidebar_open = false" aria-label="Close sidebar">
              <i class="bi bi-x-lg"></i>
            </button>
          </template>
        </PortfolioSidebar>
      </div>
    </div>

    <button v-if="!is_mobile" class="sidebar-collapse-btn btn btn-sm border bg-white text-dark translate-middle-x" @click="sidebar_collapsed = !sidebar_collapsed">
      <i :class="sidebar_collapsed ? 'bi bi-chevron-double-right' : 'bi bi-chevron-double-left'"></i>
    </button>

    <div class="col vh-100 d-flex flex-column overflow-hidden no-scrollbar">
    <HeaderSection 
        :breadcrumb="breadcrumb"
        @breadcrumb-click="handleBreadcrumbClick"
        @open-assistant="showAssistant = true"
        @toggle-mobile-sidebar="toggle_mobile_sidebar"
    />

<div class="container-fluid p-0 profile-page flex-grow-1 min-h-0 d-flex flex-column">

    <div v-if="show_error_snackbar && error" class="toast-container position-fixed bottom-0 end-0 p-3" aria-live="polite" aria-atomic="true">
        <div class="toast show align-items-center text-white border-0 shadow-lg auth-toast auth-toast-error" role="alert">
            <div class="d-flex align-items-center gap-3 p-3">
                <span class="auth-toast-icon rounded-circle d-inline-flex align-items-center justify-content-center flex-shrink-0 fs-6" aria-hidden="true">
                    <i class="bi bi-exclamation-circle"></i>
                </span>
                <div class="toast-body p-0 fw-semibold lh-sm">{{ error }}</div>
                <button type="button" class="btn-close btn-close-white ms-auto flex-shrink-0" aria-label="Dismiss error message" @click="clear_error"></button>
            </div>
        </div>
    </div>

    <!-- LOADING STATE -->
    <div v-if="loading" class="text-sm d-flex flex-column align-items-center justify-content-center text-center py-5 px-3 text-dark">
        <div class="spinner-border sp-spinner text-warning" role="status">
            <span class="visually-hidden">Loading...</span>
        </div>
        <p class="text-secondary mt-3 mb-0">Loading profile...</p>
    </div>

    <!-- ERROR STATE -->
    <div v-else-if="error" class="text-sm d-flex flex-column align-items-center justify-content-center text-center py-5 px-3 text-dark">
        <span class="sp-state-icon d-inline-flex align-items-center justify-content-center rounded-circle fs-5 mb-3 text-warning-emphasis bg-warning-subtle"><i class="bi bi-person-exclamation"></i></span>
        <p class="fw-semibold mb-1">Unable to load profile data</p>
        <button type="button" class="btn d-inline-flex align-items-center justify-content-center gap-2 text-sm btn-light border text-nowrap text-decoration-none mt-2" @click="loadUserProfile">
            <i class="bi bi-arrow-clockwise"></i> Try again
        </button>
    </div>

    <!-- PROFILE CONTENT -->
    <div v-else>
        <section class="container-xl px-3 py-4 w-100 mx-auto text-dark">
            <p class="aic-page-eyebrow text-uppercase fw-bold mb-2 text-warning">Account overview</p>

            <!-- HERO -->
            <div class="card shadow-sm rounded-4 sp-profile-hero position-relative overflow-hidden">
                <div class="sp-profile-cover border-bottom border-warning" aria-hidden="true"></div>
                <div class="sp-profile-hero-body px-3 px-md-4 d-flex flex-column flex-md-row align-items-center align-items-md-end gap-4 pt-3 pb-4 text-center text-md-start">
                    <div class="sp-avatar-xl d-inline-flex align-items-center justify-content-center flex-shrink-0 rounded-circle user-select-none fw-bold text-dark bg-warning fs-2">{{ avatar_initials }}</div>

                    <div class="sp-profile-identity flex-grow-1 min-w-0">
                        <h1 class="sp-profile-name fw-bold mb-2 text-dark fs-3 lh-sm">{{ fullName }}</h1>
                        <div class="sp-profile-meta d-flex flex-wrap align-items-center justify-content-center justify-content-md-start row-gap-2 column-gap-3 text-secondary text-sm">
                            <span class="badge rounded-pill border fw-semibold bg-warning-subtle text-warning-emphasis border-warning-subtle d-inline-flex align-items-center text-nowrap gap-1 py-1 px-2 lh-sm"><i class="bi bi-shield-check"></i>{{ userRole }}</span>
                            <span class="sp-meta-item d-inline-flex align-items-center min-w-0 gap-2"><i class="bi bi-envelope"></i>{{ userEmail }}</span>
                            <span class="sp-meta-item d-inline-flex align-items-center min-w-0 gap-2"><i class="bi bi-calendar3"></i>Member since {{ joinYear }}</span>
                        </div>
                    </div>

                    <router-link to="/edit_profile" class="btn d-inline-flex align-items-center justify-content-center gap-2 text-sm btn-primary sp-profile-edit flex-shrink-0 text-nowrap text-decoration-none text-dark mb-1">
                        <i class="bi bi-pencil-square"></i> Edit profile
                    </router-link>
                </div>
            </div>

            <div class="sp-profile-grid d-grid gap-3 mt-3">

                <!-- PERSONAL DETAILS -->
                <div class="card shadow-sm rounded-4 p-4">
                    <div class="sp-card-header d-flex align-items-start justify-content-between gap-3 mb-3">
                        <div>
                            <h2 class="sp-card-title fs-6 fw-bold mt-0 mb-1 mx-0 text-dark">Personal details</h2>
                            <p class="text-sm m-0 text-secondary lh-base">Your contact information and account role.</p>
                        </div>
                    </div>

                    <dl class="sp-detail-list m-0">
                        <div class="sp-detail-row d-flex flex-column flex-md-row align-items-start align-items-md-center justify-content-between">
                            <dt class="d-flex align-items-center flex-shrink-0 fw-medium"><span class="sp-icon-tile d-inline-flex align-items-center justify-content-center flex-shrink-0 rounded-3 text-warning-emphasis bg-warning-subtle"><i class="bi bi-person"></i></span>Full name</dt>
                            <dd class="m-0 min-w-0 fw-semibold text-start text-md-end">{{ fullName }}</dd>
                        </div>
                        <div class="sp-detail-row d-flex flex-column flex-md-row align-items-start align-items-md-center justify-content-between">
                            <dt class="d-flex align-items-center flex-shrink-0 fw-medium"><span class="sp-icon-tile d-inline-flex align-items-center justify-content-center flex-shrink-0 rounded-3 text-warning-emphasis bg-warning-subtle"><i class="bi bi-envelope"></i></span>Email address</dt>
                            <dd class="m-0 min-w-0 fw-semibold text-start text-md-end text-break">{{ userEmail }}</dd>
                        </div>
                        <div class="sp-detail-row d-flex flex-column flex-md-row align-items-start align-items-md-center justify-content-between">
                            <dt class="d-flex align-items-center flex-shrink-0 fw-medium"><span class="sp-icon-tile d-inline-flex align-items-center justify-content-center flex-shrink-0 rounded-3 text-warning-emphasis bg-warning-subtle"><i class="bi bi-telephone"></i></span>Phone number</dt>
                            <dd class="m-0 min-w-0 fw-semibold text-start text-md-end" :class="{ 'text-secondary': !hasPhoneNumber }">{{ userPhone }}</dd>
                        </div>
                        <div class="sp-detail-row d-flex flex-column flex-md-row align-items-start align-items-md-center justify-content-between">
                            <dt class="d-flex align-items-center flex-shrink-0 fw-medium"><span class="sp-icon-tile d-inline-flex align-items-center justify-content-center flex-shrink-0 rounded-3 text-warning-emphasis bg-warning-subtle"><i class="bi bi-shield-check"></i></span>Role</dt>
                            <dd class="m-0 min-w-0 fw-semibold text-start text-md-end text-capitalize">{{ userRole }}</dd>
                        </div>
                    </dl>
                </div>

                <!-- PROFILE COMPLETION -->
                <div class="card shadow-sm rounded-4 p-4">
                    <div class="sp-card-header d-flex align-items-start justify-content-between gap-3 mb-3">
                        <div>
                            <h2 class="sp-card-title fs-6 fw-bold mt-0 mb-1 mx-0 text-dark">Profile completion</h2>
                            <p class="text-sm m-0 text-secondary lh-base">
                                <template v-if="remainingItems === 0">Your profile is complete.</template>
                                <template v-else>{{ remainingItems }} item{{ remainingItems !== 1 ? 's' : '' }} left to complete.</template>
                            </p>
                        </div>
                    </div>

                    <div class="sp-completion d-flex flex-column flex-md-row align-items-stretch align-items-md-center gap-4">
                        <div class="sp-ring position-relative flex-shrink-0 align-self-center" role="img" :aria-label="`Profile ${profileProgress}% complete`">
                            <svg class="w-100 h-100" viewBox="0 0 120 120" aria-hidden="true">
                                <circle class="sp-ring-track" cx="60" cy="60" r="52" />
                                <circle
                                    class="sp-ring-value"
                                    cx="60" cy="60" r="52"
                                    :stroke-dasharray="ring_circumference"
                                    :stroke-dashoffset="ring_offset"
                                />
                            </svg>
                            <span class="sp-ring-label position-absolute top-0 start-0 end-0 bottom-0 d-flex align-items-center justify-content-center fw-bold text-dark fs-3">{{ profileProgress }}<small class="fw-semibold">%</small></span>
                        </div>

                        <ul class="sp-checklist flex-grow-1 min-w-0 m-0 list-unstyled">
                            <li v-for="item in completion_items" :key="item.key" class="d-flex align-items-center" :class="{ 'is-done': item.done }">
                                <span class="sp-check d-inline-flex align-items-center justify-content-center flex-shrink-0 rounded-circle" aria-hidden="true">
                                    <i :class="item.done ? 'bi bi-check-lg' : 'bi bi-dot'"></i>
                                </span>
                                <span class="sp-checklist-label flex-grow-1">{{ item.done ? item.done_label : item.todo_label }}</span>
                                <router-link v-if="!item.done" to="/edit_profile" class="fw-semibold text-warning-emphasis text-xs text-decoration-none">Add</router-link>
                            </li>
                        </ul>
                    </div>
                </div>

            </div>
        </section>
    </div>

    <!-- AIC Assistant -->
    <BolideAssistant :is_open="showAssistant" @close-assistant="showAssistant = false" />

</div>
    </div>
  </div>
</div>
